import { useTLang } from 'intl/intl';

export function useOutOfStockLang() {
  return {
    title: useTLang({ id: 'menuPage.outOfStock.title' }),
  };
}
